module.exports = __webpack_public_path__ + "img/11.mostly-cloudy-light.439cc328.svg";